import type { InboundMessage } from '../lib/replies'
import { AttachmentList } from './AttachmentList'
import { fmtRelative } from '../lib/format'

export function InboundBlock({ item, attachmentBase = '/api/inbound/attachments' }: { item: InboundMessage; attachmentBase?: string }) {
  return (
    <div className="border-l-2 border-paper-dim pl-3">
      <p className="text-xs text-paper-trace">
        {item.from_name ?? item.from_email} answered · {fmtRelative(item.received_at)}
        {item.spam_flag && <span className="ml-1 px-1 rounded-sm border border-red-400 text-red-400">Spam</span>}
        {item.auto_reply && ' · automatic reply'}
        {item.sender_mismatch && ` · from ${item.from_email}, not the address we wrote to`}
      </p>
      <p className="text-paper whitespace-pre-wrap text-sm">{item.body_text}</p>
      <AttachmentList ownerId={item.id} attachments={item.attachments} base={attachmentBase} />
    </div>
  )
}
